import Vue from "vue";
import Vuex from "vuex";
import "es6-promise/auto";

import auth from './modules/auth';
import requestHandler from './modules/requestHandler';
import employee from './modules/employee';
import modificationRequest from './modules/modificationRequest';
import hrSupport from './modules/hrSupport';
import supportBusiness from './modules/supportBusiness';
import supportTechnique from './modules/supportTechnique';
import mission from './modules/mission';
import chat from './modules/chat';
import classification from './modules/classification';
import profile from './modules/profile';
import recruitment from './modules/recruitment';
import notification from './modules/notification';
import contract from './modules/contract';
import psySocialSupport from './modules/psySocialSupport';
import categories from './modules/category';
import descriptionSheets from './modules/descriptionSheets';
import suggestionDescriptionSheets from './modules/suggestionDescriptionSheets';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    requestHandler,
    employee,
    modificationRequest,
    hrSupport,
    supportBusiness,
    supportTechnique,
    mission,
    chat,
    classification,
    profile,
    recruitment,
    notification,
    contract,
    categories,
    descriptionSheets,
    suggestionDescriptionSheets,
    psySocialSupport
  },
  state: {
    redirectRouter: null
  },
  getters: {
    redirectRouter: (state) => state.redirectRouter
  },
  mutations: {
    SET_REDIRECT_ROUTER(state, router) {
      state.redirectRouter = router;
    }
  },
  actions: {
    setRedirectRouter(store, router) {
      store.commit('SET_REDIRECT_ROUTER', router);
    },
    resetRedirectRouter(store) {
      store.commit('SET_REDIRECT_ROUTER', null);
    },
  }
});
